import { TaskList } from 'generated';

export class PathResolver {
    constructor() {
        this.windMap = {};
        this.itemsMap = {};
        this.createObjectTree();
    }

    getWindowIdByPath(path) {
        let paths = path.split(".");
        let node = this.objTree;
        const excludedParts = ["Ресурсы", "Окна", "Графический интерфейс"];
        for (let i = 0; i < paths.length; i++) {
            const part = paths[i];
            if (excludedParts.indexOf(part) !== -1) {
                continue;
            }

            if (typeof node[part] !== "undefined") {
                node = node[part];
            } else {
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t("title_window_not_found"),
                    text: String.format(i18next.t("window_not_found_path"), path),
                });
                return;
            }
        }
        return node;
    }

    async getLuaName(path) {
        let arr = this.screenInfo.projectTree;
        const paths = path.split(".");
        for (let part of paths) {
            const { Childs, LuaName } = arr.find(({ Name }) => Name === part);
            if (LuaName) {
                return LuaName;
            }
            arr = Childs;
        }
    }

    getWindowIdByName(winName, objId) {
        let objWinds = this.windMap[objId];
        if (typeof objWinds !== "undefined") {
            return winName.split(".").reduce((acc, val) => acc ? acc[val] : null, objWinds);
        }
    }

    getNodeFullName(node) {
        let res = node._Name;
        let p = node._Parent;
        while (p !== this.objTree) {
            res = p._Name + "." + res;
            p = p._Parent;
        }
        return res;
    }

    getFullNameIfInInstance(objId) {
        let obj = this.itemsMap[objId];
        if (typeof obj !== "undefined") {
            let p = obj._Parent;
            while (p !== this.objTree) {
                if (p._Type == "ObjectInstance") {
                    return this.getNodeFullName(obj);
                }
                p = p._Parent;
            }
        }
        return null;
    }

    getObjectIdByPath(path) {
        let paths = path.split(".");
        let node = this.objTree;
        let objId = 0;
        let outerpath = "";
        for (let i = 0; i < paths.length; i++) {
            const part = paths[i];
            if (part === "Ресурсы" || part === "Окна") continue;
            let child = node[part];
            if (typeof child === "undefined") break;

            if (
                child._Type === "ObjectInstance" &&
                typeof child._ID !== "undefined"
            ) {
                if (objId === 0) objId = child._ID;
                else if (child._LuaName) outerpath += child._LuaName + ".";
            }
            node = child;
        }
        return { objectid: objId, outerpath: outerpath };
    }

    async createObjectTree() {
        this.objTree = {};
        this.vmInfo = await this.loadJSON("VMInfo.json");
        this.addObjTreeData(this.vmInfo.projectTree, "ObjectRoot");
        this.addObjTreeData(this.vmInfo.projectTree, "SystemRoot");

        if (TaskList.name) {
            await this.mergeScreenInfo();
        }
    }

    async mergeScreenInfo() {
        // файл "ScreenInfo.json" будет только при наличии задачи экрана
        this.screenInfo = await this.loadJSON("ScreenInfo.json");
        const objectRootTree = this.screenInfo.projectTree.find(obj => obj.TranslitedName === 'ObjectRoot');
        if (objectRootTree?.Childs?.length) {
            const initialObj = this.objTree[objectRootTree.Name];

            const searchNewData = (sourceObj, childs) => {
                childs.forEach(newObj => {
                    const newSourceObj = sourceObj[newObj.Name];
                    if (newSourceObj) {
                        searchNewData(newSourceObj, newObj.Childs);
                    } else {
                        sourceObj[newObj.Name] = this.createItem(newObj, $WinDefs.winMap, sourceObj)
                    }
                });
            }

            if (initialObj)
                searchNewData(initialObj, objectRootTree.Childs);
        }
    }


    addObjTreeData(projectTree, TranslitedName) {
        const objTree = projectTree.find(obj => obj.TranslitedName === TranslitedName);
        if (objTree) {
            this.objTree[objTree.Name] = this.createItem(objTree, $WinDefs.winMap, this.objTree);
        }
    }

    getChilds(treeEl, windMap, parent) {
        if (treeEl?.Childs?.length) {
            for (let child of treeEl.Childs) {
                const type = child.Type;
                if (type === "Object" || type === "ObjectInstance" || type === "Controller" || type === "Folder") {
                    parent[child.Name] = this.createItem(child, windMap, parent);
                }
            }
        }
    }

    createItem(element, windMap, parent) {
        let result = {
            _ID: element.ID,
            _Name: element.Name,
            _Description: element.Description,
            _Type: element.Type,
            _Parent: parent,
        };
        this.itemsMap[element.ID] = result;
        if (element.LuaName) result._LuaName = element.LuaName;
        if (element.Type === "Object" || element.Type === "Controller") {
            if (typeof windMap[element.ID] !== "undefined") {
                let tempMap = windMap[element.ID];
                this.windMap[element.ID] = { ...tempMap };
                result = {
                    ...result,
                    ...tempMap,
                };
            }
        } else if (element.Type === "ObjectInstance") {
            if (typeof this.vmInfo.types !== "undefined") {
                let type = this.vmInfo.types.find(
                    x => x.Name === element.STType
                );
                let tempMap = type.Windows;
                this.windMap[element.ID] = { ...tempMap };
                result = {
                    ...result,
                    ...tempMap,
                };
            }
        }
        this.getChilds(element, windMap, result);

        return result;
    }

    loadJSON(path) {
        return new Promise(resolve => {
            const xobj = new XMLHttpRequest();
            xobj.overrideMimeType("application/json");
            xobj.open("GET", path, true);
            xobj.onreadystatechange = function () {
                if (xobj.readyState === 4 && xobj.status === 200) {
                    try {
                        resolve(JSON.parse(xobj.responseText));
                    } catch (e) { }
                }
            };
            xobj.send(null);
        });
    }
}
